import { INITIALIZATION_STATE_LOADING, INITIALIZATION_STATE_SUCCEEDED } from '../stores/app';

export const isInitialized = (state) => state.app.initializationState === INITIALIZATION_STATE_SUCCEEDED;

export const isInitializing = (state) => state.app.initializationState === INITIALIZATION_STATE_LOADING;
